import moment from "moment";

var timeFormat = 'hh:mm:ss';

function getHoursSinceDate(days, installationDate, timePeriod = 'hours') {
    var today = moment();
    if (!installationDate) {
        return 0;
    }

    if (installationDate.isBefore(moment().subtract(days, 'd'))) {
        return today.diff(moment().subtract(days, 'd'), timePeriod);
    } else {
        return today.diff(installationDate, timePeriod);
    }
}



export function generateUptime(installationDate, serviceCollection) {
    

    if (!installationDate || !serviceCollection) {
        return {
            allTime: 100,
            days365: 100,
            days90: 100,
            days30: 100
        }
    }

    

    function generatePercent(downtimeHours, totalHours) {
        return ((1 - (downtimeHours / totalHours)) * 100).toFixed(2);
    }

    var totalDownTimeHours = 0;
    var totalDownTime365Days = 0;
    var totalDownTime90Days = 0;
    var totalDownTime30Days = 0;

    var totalHours = moment().diff(installationDate, 'hours');
    var totalHours365 = getHoursSinceDate(365, installationDate);
    var totalHours90 = getHoursSinceDate(90, installationDate);
    var totalHours30 = getHoursSinceDate(30, installationDate);

    serviceCollection.forEach((service) => {
        if (service.serviceType === 'Breakdown') {
            var finishedDate = service.dueDate ? moment(service.dueDate) : moment();

            if (moment(service.startDate).isAfter(moment().subtract(365, 'd'))) {
                totalDownTime365Days += moment.duration(finishedDate.diff(service.startDate)).hours();
            }

            if (moment(service.startDate).isAfter(moment().subtract(90, 'd'))) {
                totalDownTime90Days += moment.duration(finishedDate.diff(service.startDate)).hours();
            }

            if (moment(service.startDate).isAfter(moment().subtract(30, 'd'))) {
                totalDownTime30Days += moment.duration(finishedDate.diff(service.startDate)).hours();
            }

            totalDownTimeHours += moment.duration(finishedDate.diff(service.startDate)).hours();
        }

    });

    return {
        allTime: generatePercent(totalDownTimeHours, totalHours),
        days365: generatePercent(totalDownTime365Days, totalHours365),
        days90: generatePercent(totalDownTime90Days, totalHours90),
        days30: generatePercent(totalDownTime30Days, totalHours30)
    }
}

export function secondsToReadableTime(seconds) {
    var days = Math.floor(seconds / 86400);
    var hours = Math.floor((seconds % 86400) / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);

    var dayString = days > 0 ? `${days}d` : '';
    var hourString = hours > 0 ? `${hours}h` : '';
    var minuteString = minutes > 0 ? `${minutes}m` : '';

    var timeArray = [dayString, hourString, minuteString].filter(t => t.length > 0);

    if (timeArray.length === 0) {
        return "0m";
    }
    return timeArray.join(' ');
}

export function generateRuntime(runtimeCollection, installationDate) {
    var totalSeconds = 0;
    var totalSeconds365 = 0;
    var totalSeconds90 = 0;
    var totalSeconds30 = 0;

    var beforeTime = moment('09:00:00', timeFormat),
        afterTime = moment('17:00:00', timeFormat);
    var totalDays = moment().diff(installationDate, 'days');

    var secondsPerDays = afterTime.diff(beforeTime, 'seconds');

    var totalDays365 = getHoursSinceDate(365, installationDate, 'days');
    var totalDays90 = getHoursSinceDate(90, installationDate, 'days');
    var totalDays30 = getHoursSinceDate(30, installationDate, 'days');

    
    runtimeCollection.forEach((runtime) => {
        var start = moment.unix(runtime.startTime).utc(0).local();

        if (moment(start).isBefore(moment(installationDate))) {
            return;
        }

        var secondsRun = runtime.endTime - runtime.startTime;

        if (start.isAfter(moment().subtract(365, 'd'))) {
            totalSeconds365 += secondsRun;
        }

        if (start.isAfter(moment().subtract(90, 'd'))) {
            totalSeconds90 += secondsRun;
        }

        if (start.isAfter(moment().subtract(30, 'd'))) {
            totalSeconds30 += secondsRun;
        }

        totalSeconds += secondsRun;

    });

    return {
        allTime: secondsToReadableTime(totalSeconds),
        days365: secondsToReadableTime(totalSeconds365),
        days90: secondsToReadableTime(totalSeconds90),
        days30: secondsToReadableTime(totalSeconds30),
        allTimeUtilization: totalDays > 0 ? ((totalSeconds / (totalDays * secondsPerDays)) * 100).toFixed(2) : 0.00,
        utilization30: totalDays30 > 0 ? ((totalSeconds30 / (totalDays30 * secondsPerDays)) * 100).toFixed(2) : 0.00,
        utilization90: totalDays90 > 0 ? ((totalSeconds90 / (totalDays90 * secondsPerDays)) * 100).toFixed(2) : 0.00,
        utilization365: totalDays365 > 0 ? ((totalSeconds365 / (totalDays365 * secondsPerDays)) * 100).toFixed(2) : 0.00
    };
}